<template>
  <div class="list-box bg-gray-100 rounded-lg">
    <div
      class="nav gap-x-3"
      title="HuiYiDetailRiChengList"
      data-title="坐席管理"
    >
      <el-input
        v-model="state.params.keywords"
        class="c-search-white"
        clearable
        placeholder="关键字"
        @keyup.enter="onLoad()"
        @clear="onLoad()"
      >
        <template #suffix>
          <el-icon
            @click="onLoad()"
            color="#a2a2a2"
            title="搜索"
            class="font-bold cursor-pointer hover:opacity-60"
            ><Search
          /></el-icon>
        </template>
      </el-input>
      <el-button
        type="primary"
        icon="Plus"
        @click="
          delete state.selectId;
          state.showInfo = true;
        "
        v-if="!props.search"
      >
        新建
      </el-button>
    </div>
    <div class="content c-table-box mt-2 bg-white rounded-lg p-4 text-gray-400">
      敬请期待……
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
export default {
  props: {
    meeting_id: Number,
    meeting_schedule_id: Number,
    meeting_schedule_name: String,
    search: Boolean,
  },
  setup(props) {
    const state = reactive({
      params: {},
    });
    onMounted(() => {});
    return { state, props };
  },
};
</script>

<style lang="less" scoped></style>
